/**
 * Adzuki.CharacterCount
 * Needs the class/id of the div with the image to be magnified
 */

(function MagnifierGlass($, Adzuki)
{
	"use strict";

	// TODO: Allow passing of offset params for cursor image limits (top,bottom,left, etc.). See moveMagnifier()
	var magnifierGlass = function _magnifierGlass(el, zoom = 3)
	{
		try {
			if (typeof el === 'string') {
				this.magnified_target = $(el);
			}
			
			if (typeof el === 'object') {
				this.magnified_target = el;
			}
			
			if (!this.magnified_target.length) {
				throw new Error('cannot find ' + el);
			}
			
		} catch (e) {
			console.log('[Adzuki.MagnifierGlass]', e);
		}
		
		this.magnified_target.each(function loopContainers() {
			initMagnifier($(this));
		});
		
		/**
		 * Initializes the magnifier
		 * @param $container the container element
		 */
		function initMagnifier ($container)
		{
			let $magnified_image = $container.find('img');
			$magnified_image.on('load', function initMagnifier() {
				if ($container.find('.img-magnifier-glass').length === 0) {
					$container.append('<div class="img-magnifier-glass"></div>');
					let $magnifier_glass = $container.find('.img-magnifier-glass');
					// set background properties for the magnifier glass:
					$magnifier_glass.css('backgroundImage', "url('" + $magnified_image.attr('src') + "')");
					$magnifier_glass.css('backgroundRepeat', 'no-repeat');
					$magnifier_glass.css('backgroundSize', ($magnified_image.width() * zoom + 'px ' + $magnified_image.height() * zoom + 'px'));
					
					$(window).resize(function onResize() {
						$magnifier_glass.css('backgroundSize', ($magnified_image.width() * zoom + 'px ' + $magnified_image.height() * zoom + 'px'));
					});

					// Add event listeners for mouse over image
					$magnifier_glass.on('mousemove', function listenerGlass(e) {
						moveMagnifier(e, $magnified_image, $magnifier_glass);
					});
					$magnifier_glass.on('touchmove', function listenerGlass(e) {
						moveMagnifier(e, $magnified_image, $magnifier_glass);
					});
					$magnified_image.on('mousemove', function listenerImage(e) {
						moveMagnifier(e, $magnified_image, $magnifier_glass);
					});
					$magnified_image.on('touchmove', function listenerImage(e) {
						moveMagnifier(e, $magnified_image, $magnifier_glass);
					});
				}
			}).each(function error() {
				if (this.complete) {
					$(this).trigger('load');
				}
			});
		}
		
		/**
		 * Moves the magnifying lens
		 * @param e event
		 * @param $image the target image element
		 * @param $lens the lens element that shows the zoomed image
		 */
		function moveMagnifier(e, $image, $lens)
		{
			e.preventDefault();
			let cursor_position, cursor_x, cursor_y;
			let off, lens_offset_width, lens_offset_height;

			// get the cursor's x and y positions:
			cursor_position    = getCursorPos(e, $image);
			cursor_x           = cursor_position.x;
			cursor_y           = cursor_position.y;
			off                = 3;
			lens_offset_width  = $lens[0].offsetWidth / 2;
			lens_offset_height = $lens[0].offsetHeight / 2;
			
			$lens.addClass('active');

			// prevent the magnifier glass from being positioned outside the image:
			// Cursor right side of image limit
			if (cursor_x >= $image[0].width - (lens_offset_width / zoom) + 20) {
				cursor_x = $image[0].width - (lens_offset_width / zoom);
				$lens.removeClass('active');
			}
			
			// Cursor left side of image limit
			if (cursor_x < lens_offset_width / zoom - 20) {
				cursor_x = lens_offset_width / zoom;
				$lens.removeClass('active');
			}
			
			// Cursor bottom side of image limit
			if (cursor_y >= $image[0].height - (lens_offset_height / zoom) + 5) {
				cursor_y = $image[0].height - (lens_offset_height / zoom);
				$lens.removeClass('active');
			}
			
			// Cursor top side of image limit
			if (cursor_y < lens_offset_height / zoom - 20) {
				cursor_y = lens_offset_height / zoom;
				$lens.removeClass('active');
			}
			
			// set the position of the magnifier glass:
			$lens.css('left', (cursor_x - lens_offset_width) + 'px');
			$lens.css('top', (cursor_y - lens_offset_height) + 'px');
			
			// display what the magnifier glass "sees":
			$lens.css('backgroundPosition', '-' + ((cursor_x * zoom) - lens_offset_width + off) + 'px -' + ((cursor_y * zoom) - lens_offset_height + off) + 'px');
		}
		
		/**
		 * Gets the cursors position
		 * @param e
		 * @param $image
		 * @returns {{x: number, y: number}}
		 */
		function getCursorPos(e, $image) {
			let image_position, x, y;
			
			image_position = $image[0].getBoundingClientRect();
			
			// calculate the cursor's x and y coordinates, relative to the image:
			x = e.pageX - image_position.left;
			y = e.pageY - image_position.top;
			
			// handle page scrolling:
			x = x - window.scrollX;
			y = y - window.scrollY;
			
			return {
				x: x,
				y: y
			};
		}
	};

	Adzuki.MagnifierGlass = magnifierGlass;
}(jQuery, window.Adzuki || {}));
